import { type Ripple } from "@dashboard/ripples/types";

export const rippleOrderChannelInHeader: Ripple = {
  type: "improvement",
  ID: "order-channel-in-header",
  TTL_seconds: 60 * 60 * 24 * 7,
  content: {
    oneLiner: "Order Channel in Header",
    contextual: "주문 채널이 헤더에 표시됩니다. 클릭하여 동일한 채널의 다른 주문을 볼 수 있습니다.",
    global:
      "주문 채널이 헤더에 표시되며, 주문 날짜와 상태 옆에 표시됩니다. 채널을 클릭하여 동일한 채널의 주문 목록을 볼 수 있습니다. 채널 설정으로 이동하는 대신 동일한 채널의 주문 목록을 볼 수 있습니다.",
  },
  dateAdded: new Date(2026, 4, 26),
};
